import PubSub from 'pubsub-js';
import { gsap } from 'gsap';

const header = {
  $header: document.getElementById('main_header'),
  $sidebar: document.querySelector('aside.main_menu'),
  init() {
    console.log('Header init');

    this.setUpListeners();
  },

  setUpListeners() {
    PubSub.subscribe(
      'header.updateMenuItems',
      this.updateMenuItems.bind(this)
    );

    PubSub.subscribe(
      'header.toggleColor',
      this.toggleColor.bind(this)
    );

    PubSub.subscribe(
      'header.closeMenu',
      this.closeMenu.bind(this)
    );

    this.$header
      .querySelector('.menu_toggler')
      .addEventListener('click', this.openMenu.bind(this));

    this.$sidebar
      .addEventListener('click', ev => {
        if (ev.target === this.$sidebar
        || ev.target.closest('.menu_toggler') !== null) {
          this.closeMenu();
        }
      });

    document
      .querySelectorAll('.to_top')
      .forEach($button => {
        $button.addEventListener('click', () => {
          jQuery('html,body').animate({scrollTop: 0});
        });
      });
  },

  openMenu() {
    this.$sidebar.classList.add('active');
  },

  closeMenu() {
    this.$sidebar.classList.remove('active');
  },

  updateMenuItems(ev, $newHeader) {
    const $currMenuItems = this.$header.querySelectorAll('.menu-item');

    $newHeader
      .querySelectorAll('.menu-item')
      .forEach(($el, id) => {
        $currMenuItems[id]
          .setAttribute(
            'class',
            $el.getAttribute('class')
          );
      });
  },

  toggleColor(ev, bgColor) {
    if (bgColor === 'FFFFFF' && !this.$header.classList.contains('dark')) {
      this.$header.classList.add('dark');
    } else if (bgColor !== 'FFFFFF'
      && this.$header.classList.contains('dark')) {
      this.$header.classList.remove('dark');
    }
  }
};


export default header;
